var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fade"}},[_c('div',{staticClass:"audio-line"},_vm._l((16),function(index){return _c('div',{key:index,staticClass:"line audioAn"})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }